<!-- Hero Banner -->
<div class="dashboard-hero-wrap">
  <section class="dashboard-hero">
    <div class="dashboard-hero__bg"></div>
    <div class="dashboard-hero__content">
      <span class="dashboard-hero__ornament" aria-hidden="true">✦ ☾ ✦</span>
      <h1 class="dashboard-hero__title">{{ 'dashboard.hero.app_name' | translate }}</h1>
      <p class="dashboard-hero__tagline">{{ 'dashboard.hero.tagline' | translate }}</p>
      <span class="dashboard-hero__greeting">{{ 'common.assalamu_alaikum' | translate }}, {{ userName }} <span aria-hidden="true">🤍</span></span>
      <button type="button" class="dashboard-hero__location">📍 {{ location }} ▾</button>
    </div>
  </section>

  <!-- Overlay cards (outside the banner, inside the wrapper) -->
  <div class="dashboard-hero__prayer-card">
    <span class="dashboard-hero__card-label">{{ 'common.next_prayer' | translate }}</span>
    <div class="dashboard-hero__prayer-row">
      <span class="dashboard-hero__prayer-time">{{ upcomingPrayer.time }}</span>
      <div class="dashboard-hero__prayer-name-col">
        <span class="dashboard-hero__prayer-name">{{ upcomingPrayer.name }}</span>
        <span aria-hidden="true">🕌</span>
      </div>
    </div>
    <span class="dashboard-hero__prayer-countdown">{{ upcomingPrayer.countdown }} <small>{{ 'common.to_go' | translate }}</small></span>
    <a [routerLink]="routes.DASHBOARD_PRAYER_TIMES" class="dashboard-hero__card-link">{{ 'common.view_all_prayer_times' | translate }}</a>
  </div>

  <div class="dashboard-hero__date-card">
    <span class="dashboard-hero__card-label">{{ 'common.today' | translate }}</span>
    <span class="dashboard-hero__date-gregorian">{{ gregorianDate.day }} {{ gregorianDate.month }} {{ gregorianDate.year }}</span>
    <span class="dashboard-hero__date-weekday">{{ gregorianDate.weekday }}</span>
    <span class="dashboard-hero__date-hijri">{{ hijriDate.day }} {{ hijriDate.month }} {{ hijriDate.year }} {{ 'dashboard.date_card.ah' | translate }}</span>
    <div class="dashboard-hero__sun-row">
      <span class="dashboard-hero__sun-item">🌅 {{ 'dashboard.date_card.sunrise' | translate }} <strong>{{ sunrise }}</strong></span>
      <span class="dashboard-hero__sun-item">🌇 {{ 'dashboard.date_card.sunset' | translate }} <strong>{{ sunset }}</strong></span>
    </div>
  </div>
</div>

<div class="dashboard">

  <!-- Lifetime Kaza | Today's Progress | Kaza Namaz -->
  <div class="dashboard__row dashboard__row--three">

    <div class="lifetime-kaza">
      <div class="lifetime-kaza__header">
        <span class="lifetime-kaza__infinity">∞</span>
        <div class="lifetime-kaza__title-text">
          <span class="lifetime-kaza__title">{{ 'dashboard.kaza.lifetime_title' | translate }}</span>
          <span class="lifetime-kaza__sub">{{ lifetimeKaza.daysSinceAge7 }} {{ 'dashboard.kaza.days_since' | translate }}</span>
        </div>
      </div>
      <div class="lifetime-kaza__stats">
        <div class="lifetime-kaza__stat">
          <span class="lifetime-kaza__stat-val lifetime-kaza__stat-val--missed">{{ lifetimeKaza.totalMissed }}</span>
          <span class="lifetime-kaza__stat-label">{{ 'dashboard.kaza.total_missed' | translate }}</span>
        </div>
        <div class="lifetime-kaza__stat-sep"></div>
        <div class="lifetime-kaza__stat">
          <span class="lifetime-kaza__stat-val lifetime-kaza__stat-val--completed">{{ lifetimeKaza.completed }}</span>
          <span class="lifetime-kaza__stat-label">{{ 'common.completed' | translate }}</span>
        </div>
        <div class="lifetime-kaza__stat-sep"></div>
        <div class="lifetime-kaza__stat">
          <span class="lifetime-kaza__stat-val lifetime-kaza__stat-val--remaining">{{ lifetimeKaza.remaining }}</span>
          <span class="lifetime-kaza__stat-label">{{ 'dashboard.kaza.remaining' | translate }}</span>
        </div>
      </div>
      <div class="lifetime-kaza__progress">
        <div class="lifetime-kaza__progress-header">
          <span class="lifetime-kaza__progress-label">{{ 'dashboard.kaza.overall_progress' | translate }}</span>
          <span class="lifetime-kaza__progress-pct">{{ lifetimeKaza.percentDone }}{{ 'dashboard.kaza.percent_done' | translate }}</span>
        </div>
        <div class="lifetime-kaza__bar">
          <div class="lifetime-kaza__bar-fill" [style.width.%]="lifetimeKaza.percentDone"></div>
        </div>
      </div>
      <a [routerLink]="routes.DASHBOARD_KAZA_TRACKER" class="card__link">{{ 'dashboard.kaza.view_tracker' | translate }}</a>
    </div>

    <app-card class="today-progress-card">
      <div class="today-progress-card__head">
        <span aria-hidden="true">📊</span>
        <span class="card__title">{{ 'dashboard.today_progress.title' | translate }}</span>
      </div>
      <div class="today-progress-card__body">
        <app-ring-progress [percent]="todayProgressPercent" [size]="80"></app-ring-progress>
        <ul class="today-progress-card__list">
          @for (item of todayChecklist; track item.name) {
            <li class="today-progress-card__item"
                [class.today-progress-card__item--done]="item.done === true"
                [class.today-progress-card__item--pending]="item.done === false">
              @if (item.done === true) {
                <span class="today-progress-card__check today-progress-card__check--done" aria-hidden="true">✓</span>
              } @else {
                <span class="today-progress-card__check" aria-hidden="true">🕐</span>
              }
              <span class="today-progress-card__name">{{ item.name }}</span>
              <span class="today-progress-card__status"
                    [class.today-progress-card__status--done]="item.done === true"
                    [class.today-progress-card__status--pending]="item.done === false">
                @if (item.done === null) { — }
                @else if (item.done) { {{ 'common.completed' | translate }} }
                @else { {{ 'common.pending' | translate }} }
              </span>
            </li>
          }
        </ul>
      </div>
      <a [routerLink]="routes.DASHBOARD_AMAAL_PLANNER" class="card__link">{{ 'dashboard.today_progress.view_full' | translate }}</a>
    </app-card>

    <app-card class="kaza-namaz-card">
      <div class="kaza-namaz-card__head">
        <span aria-hidden="true">🕌</span>
        <span class="card__title">{{ 'dashboard.kaza_namaz.title' | translate }}</span>
      </div>
      <div class="kaza-namaz-card__inner">
        <div class="kaza-namaz-card__stat">
          <span class="kaza-namaz-card__label">{{ 'dashboard.kaza_namaz.total_kaza' | translate }}</span>
          <span class="kaza-namaz-card__val kaza-namaz-card__val--red">{{ kazaNamaz.total }}</span>
          <span class="kaza-namaz-card__sub">{{ 'common.prayers' | translate }}</span>
        </div>
        <div class="kaza-namaz-card__divider"></div>
        <div class="kaza-namaz-card__stat">
          <span class="kaza-namaz-card__label">{{ 'common.completed' | translate }}</span>
          <span class="kaza-namaz-card__val kaza-namaz-card__val--green">{{ kazaNamaz.completed }}</span>
          <span class="kaza-namaz-card__sub">{{ 'common.prayers' | translate }}</span>
        </div>
      </div>
      <span class="kaza-namaz-card__progress-label">
        {{ 'common.progress' | translate }} &nbsp;<strong>{{ kazaNamaz.completed }}/{{ kazaNamaz.total }} {{ 'common.completed' | translate }}</strong>
      </span>
      <div class="kaza-namaz-card__bar">
        <div class="kaza-namaz-card__bar-fill" [style.width.%]="kazaNamazPercent"></div>
      </div>
      <span class="kaza-namaz-card__percent">{{ kazaNamazLabel }}</span>
      <a [routerLink]="routes.DASHBOARD_KAZA_TRACKER" class="card__link">{{ 'common.view_details' | translate }}</a>
    </app-card>

  </div>

  <!-- Prayer Times: Upcoming + Columns -->
  <div class="prayer-section">
    <div class="prayer-section__upcoming">
      <span class="prayer-section__upcoming-label">{{ 'dashboard.prayer_section.upcoming' | translate }}</span>
      <span class="prayer-section__next-name">{{ upcomingPrayer.name }}</span>
      <span class="prayer-section__next-time">{{ upcomingPrayer.time }}</span>
      <span class="prayer-section__countdown">{{ upcomingPrayer.countdown }}</span>
      <span class="prayer-section__until">{{ upcomingPrayer.until }}</span>
      <span class="prayer-section__best-label">{{ 'dashboard.prayer_section.best_time' | translate }}</span>
      <span class="prayer-section__best-time">{{ upcomingPrayer.bestTime }}</span>
    </div>
    <div class="prayer-section__all">
      <div class="prayer-section__all-header">
        <span class="prayer-section__all-title">{{ 'dashboard.prayer_section.title' | translate }}</span>
        <a [routerLink]="routes.DASHBOARD_PRAYER_TIMES" class="card__link">{{ 'common.view_all' | translate }}</a>
      </div>
      <div class="prayer-section__columns">
        @for (p of prayerTimes; track p.name) {
          <div class="prayer-section__col" [class.prayer-section__col--next]="p.isNext" [class.prayer-section__col--done]="p.done">
            <span class="prayer-section__col-icon" aria-hidden="true">{{ p.icon }}</span>
            <span class="prayer-section__col-name">{{ p.name }}</span>
            <span class="prayer-section__col-time">{{ p.time }}</span>
            <span class="prayer-section__col-best-label">{{ 'dashboard.prayer_section.best_time' | translate }}</span>
            <span class="prayer-section__col-best-range">{{ p.bestTimeFrom }}–{{ p.bestTimeTo }}</span>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Weather | Fasting | Qibla -->
  <div class="dashboard__row dashboard__row--three dashboard__row--weather-row">

    <app-card class="weather-card">

      <!-- Hero row: temp left, location+condition right -->
      <div class="weather-card__hero">
        <div class="weather-card__left">
          <span class="weather-card__icon" aria-hidden="true">🌤️</span>
          <div class="weather-card__temp-col">
            <span class="weather-card__temp">{{ weather.temperature }}°</span>
            <span class="weather-card__feels">{{ 'dashboard.weather.feels_like' | translate }} {{ weather.feelsLike }}°</span>
          </div>
        </div>
        <div class="weather-card__right">
          <span class="weather-card__location">📍 {{ weather.location }}</span>
          <span class="weather-card__condition">{{ weather.condition }}</span>
        </div>
      </div>

      <!-- Detail strip -->
      <div class="weather-card__details">
        <div class="weather-card__detail-item">
          <span class="weather-card__detail-icon" aria-hidden="true">💧</span>
          <span class="weather-card__detail-val">{{ weather.humidity }}%</span>
          <span class="weather-card__detail-label">{{ 'dashboard.weather.humidity' | translate }}</span>
        </div>
        <div class="weather-card__detail-item">
          <span class="weather-card__detail-icon" aria-hidden="true">💨</span>
          <span class="weather-card__detail-val">{{ weather.wind }}</span>
          <span class="weather-card__detail-label">{{ 'dashboard.weather.wind' | translate }}</span>
        </div>
        <div class="weather-card__detail-item">
          <span class="weather-card__detail-icon" aria-hidden="true">☀️</span>
          <span class="weather-card__detail-val">{{ weather.uv }}</span>
          <span class="weather-card__detail-label">{{ 'dashboard.weather.uv' | translate }}</span>
        </div>
      </div>

    </app-card>

    <app-card class="fasting-card">
      <div class="fasting-card__header">
        <span class="fasting-card__title">{{ 'dashboard.fasting.title' | translate }}</span>
        <span class="fasting-card__badge">{{ 'dashboard.fasting.ramadan' | translate }} {{ fasting.ramadanDay }}</span>
      </div>
      <div class="fasting-card__times">
        <div class="fasting-card__time-block">
          <span class="fasting-card__time-icon" aria-hidden="true">🍎</span>
          <span class="fasting-card__time-label">{{ 'dashboard.fasting.sehri' | translate }}</span>
          <span class="fasting-card__time-sub">{{ 'dashboard.fasting.fajr_start' | translate }}</span>
          <span class="fasting-card__time-val">{{ fasting.sehriTime }}</span>
        </div>
        <div class="fasting-card__time-divider"></div>
        <div class="fasting-card__time-block">
          <span class="fasting-card__time-icon" aria-hidden="true">🌅</span>
          <span class="fasting-card__time-label">{{ 'dashboard.fasting.iftar' | translate }}</span>
          <span class="fasting-card__time-sub">{{ 'dashboard.fasting.maghrib_start' | translate }}</span>
          <span class="fasting-card__time-val">{{ fasting.iftarTime }}</span>
        </div>
      </div>
      <div class="fasting-card__duration">
        <span>{{ 'dashboard.fasting.fast_duration' | translate }} <strong>{{ fasting.duration }}</strong></span>
      </div>
    </app-card>

    <app-card [title]="'dashboard.qibla.title' | translate" class="qibla-card" [routerLink]="routes.DASHBOARD_QIBLA_FINDER" style="cursor:pointer">
      <div class="qibla-card__body">
        <div class="qibla-card__compass-wrap" #compassWrap>
          <app-mini-compass [bearing]="qiblaDirection.degrees" [size]="compassSize()"></app-mini-compass>
        </div>
        <div class="qibla-card__stats">
          <div class="qibla-card__stat">
            <span class="qibla-card__stat-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/>
                <line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/>
                <line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/>
              </svg>
            </span>
            <span class="qibla-card__stat-text">
              <strong>{{ qiblaDirection.degrees }}°</strong>
              <span>{{ qiblaDirection.direction }}</span>
            </span>
          </div>
          <div class="qibla-card__stat">
            <span class="qibla-card__stat-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12h18M3 6h18M3 18h18"/>
              </svg>
            </span>
            <span class="qibla-card__stat-text">
              <strong>4,782 km</strong>
              <span>{{ 'qibla.to_makkah' | translate }}</span>
            </span>
          </div>
          <div class="qibla-card__stat">
            <span class="qibla-card__stat-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
              </svg>
            </span>
            <span class="qibla-card__stat-text">
              <strong>{{ location }}</strong>
              <span>{{ 'common.your_location' | translate }}</span>
            </span>
          </div>
        </div>
      </div>
    </app-card>

  </div>

  <!-- Quick Tiles -->
  <div class="quick-tiles">
    @for (tile of quickTiles; track tile.label) {
      <a [routerLink]="tile.path" class="quick-tile">
        <span class="quick-tile__icon" [style.background-color]="tile.bgColor" [style.color]="tile.color" aria-hidden="true">{{ tile.icon }}</span>
        <span class="quick-tile__label">{{ tile.label | translate }}</span>
        <span class="quick-tile__sub">{{ tile.sub | translate }}</span>
        <span class="quick-tile__detail">{{ tile.detail | translate }}</span>
        <span class="quick-tile__action" [style.color]="tile.color">{{ tile.action | translate }} ›</span>
      </a>
    }
  </div>

  <!-- Daily Reminder -->
  <app-card class="reminder-card">
    <div class="reminder-card__body">
      <div class="reminder-card__text">
        <span class="card__title">{{ 'dashboard.reminder.title' | translate }}</span>
        <p class="reminder-card__quote">"{{ dailyReminder.quote }}"</p>
        <span class="reminder-card__reference">— {{ dailyReminder.reference }}</span>
        <button type="button" class="btn btn--primary">{{ 'dashboard.reminder.read_more' | translate }}</button>
      </div>
      <span class="reminder-card__illustration" aria-hidden="true">📖</span>
    </div>
  </app-card>

  <!-- Islamic Library + Masjid -->
  <div class="dashboard__row dashboard__row--library">
    <app-card class="library-card">
      <div class="library-card__header">
        <span class="card__title">{{ 'dashboard.library.title' | translate }}</span>
        <a [routerLink]="routes.DASHBOARD_ISLAMIC_LIBRARY" class="card__link">{{ 'common.view_all' | translate }}</a>
      </div>
      <div class="library-card__grid">
        @for (category of libraryCategories; track category.label) {
          <a [routerLink]="category.path" class="library-tile">
            <span class="library-tile__icon" aria-hidden="true">{{ category.icon }}</span>
            <strong>{{ category.label | translate }}</strong>
            <span>{{ category.count | translate }}</span>
          </a>
        }
      </div>
    </app-card>

    <app-card class="masjid-card">
      <span class="card__title">{{ 'dashboard.masjid.title' | translate }}</span>
      <div class="masjid-card__body">
        <span class="masjid-card__icon" aria-hidden="true">🕌</span>
        <div class="masjid-card__info">
          <strong>{{ nearbyMasjid.name }}</strong>
          <span>{{ nearbyMasjid.distance }} {{ 'dashboard.masjid.away' | translate }}</span>
        </div>
      </div>
      <a [routerLink]="routes.DASHBOARD_MASJIDS" class="btn btn--ghost">{{ 'dashboard.masjid.get_directions' | translate }}</a>
    </app-card>
  </div>

  <!-- Continue Reading | Bookmarks | Kaza Overview -->
  <div class="dashboard__row dashboard__row--three">
    <app-card [title]="'dashboard.continue_reading.title' | translate" class="continue-reading-card">
      <div class="continue-reading-card__body">
        <span class="continue-reading-card__cover" aria-hidden="true">📗</span>
        <div class="continue-reading-card__info">
          <strong>{{ continueReading.title }}</strong>
          <span>{{ continueReading.author }}</span>
          <span class="continue-reading-card__chapter">{{ 'dashboard.continue_reading.chapter' | translate }}: {{ continueReading.chapter }}</span>
          <div class="continue-reading-card__progress-bar">
            <div class="continue-reading-card__progress-fill" [style.width.%]="continueReading.progress"></div>
          </div>
        </div>
      </div>
      <button type="button" class="btn btn--primary">{{ 'dashboard.continue_reading.resume' | translate }}</button>
    </app-card>

    <app-card class="bookmarks-card">
      <div class="bookmarks-card__header">
        <span class="card__title">{{ 'dashboard.bookmarks.title' | translate }}</span>
        <a [routerLink]="routes.DASHBOARD_QURAN" class="card__link">{{ 'common.view_all' | translate }}</a>
      </div>
      <ul class="bookmarks-card__list">
        @for (bookmark of bookmarks; track bookmark.title) {
          <li>
            <a [routerLink]="bookmark.path" class="bookmarks-card__item">
              <span aria-hidden="true">🔖</span>
              <span class="bookmarks-card__text">
                <strong>{{ bookmark.title }}</strong>
                <span>{{ bookmark.subtitle }}</span>
              </span>
            </a>
          </li>
        }
      </ul>
    </app-card>

    <app-card [title]="'dashboard.kaza_overview.title' | translate" class="kaza-overview-card">
      <div class="kaza-overview-card__body">
        <ul class="kaza-overview-card__stats">
          <li><span>{{ 'dashboard.kaza_namaz.total_kaza' | translate }}</span><strong>{{ kazaOverview.total }}</strong></li>
          <li><span>{{ 'common.completed' | translate }}</span><strong>{{ kazaOverview.completed }}</strong></li>
        </ul>
        <app-ring-progress [percent]="kazaOverviewPercent" [centerValue]="kazaOverviewPercentLabel" [size]="72"></app-ring-progress>
      </div>
      <a [routerLink]="routes.DASHBOARD_KAZA_TRACKER" class="btn btn--ghost">{{ 'dashboard.kaza.go_to_tracker' | translate }}</a>
    </app-card>
  </div>

</div>
